<div class="form-horizontal"
     style="height: 52px; border: 1px solid #aaa; border-radius: 5px; margin-top: 10px; margin-bottom: 10px">
  <div class="input-group" style="padding: 8px; width:100%;" *ngIf="!isOnlyPreview && (selectedIndex !== undefined && selectedIndex !== null)
  && (displayTemplateParameters !== undefined && displayTemplateParameters.length > 0)">
    <p-dropdown
        [options]="displayTemplateParameters"
        [(ngModel)]="selectedTemplateParameter"
        styleClass="form-control"
        [style]="{'width':'25%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
          'height':'36px','padding-left': '16px', 'font-size': '10px', 'text-shadow': 'none'}">
      <ng-template let-item pTemplate="item">
        <div *ngIf="item.label.indexOf('hr') === -1">{{item.label}}</div>
        <div *ngIf="item.label.indexOf('hr') !== -1"><hr/></div>
      </ng-template>
    </p-dropdown>
    <button class="btn btn-primary border-left-flat"
            style="width:20%; height: 36px;"
            (click)="contenteditableDirective.addParameter(selection, templateParameters, selectedTemplateParameter, selectedNode)"
            tooltip="This will be replaced at the time of sending the message">
      Insert parameter
    </button>
  </div>
</div>

<p-table #modelTemplate
         dataKey="name"
         [value]="displayModel"
         [rowHover]="true"
         class="modelTemplate table table-fixed-header"
         *ngIf="templateParameters !== undefined"
         sortMode="multiple"
         [multiSortMeta]="[{field: 'name', order: 1}]"
>
  <ng-template pTemplate="header" let-columns>
    <tr class="table-header-upper-row">
      <th class="th-upper ui-sortable-column" style="width: 20%; min-width: 180px;">
        <div style="height:28px">
        Variable Name
          <span pSortableColumn="name" style="background: transparent !important;"> <span class="caret"></span></span>
          <span style="padding-right: 16px;"></span>
          <p-dropdown
              [options]="mediaType"
              [(ngModel)]="selectedMediaType"
              styleClass="form-control"
              (onChange)="mediaTypeChanged()"
              [style]="{'width':'30px', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
            'height':'28px','padding-left': '16px', 'font-size': '10px', 'text-shadow': 'none','display': 'inline-block'}">
          </p-dropdown>
        </div>
      </th>
      <th class="th-upper" style="width: 2%; border: 1px solid #ddd;">
        <span class="glyphicon glyphicon-remove-circle" aria-hidden="true"></span>
      </th>
      <th style="width: 40%; border: 1px solid #ddd;" class="th-upper">Model in file
      </th>
      <th style="width: 2.5%; border: 1px solid #ddd;" class="th-upper">
        <div class="btn-group edit-model">
          <button type="button"
                  (click)="copyFieldsFromSourceToDBDialog($event, templateUpdateModel.updatedModel)"
                  [disabled]="isOnlyPreview"
                  class="btn btn-default toRight copy-batch">
            <span class="glyphicon glyphicon-copy icon-copy-batch" aria-hidden="true"></span>
          </button>
        </div>
      </th>
      <th style="width: 43.5%; border: 1px solid #ddd;" class="th-upper">
        <div style="float: left; position: relative; top: 8px;">Model in database</div>
        <div style="float: right; position: relative;">
          <label class="btn btn-primary"  style="color: #f2ffce; text-shadow: none;"
                 (click)="onDisplayTypeChange('html');"
                 *ngIf="!modelIsLoading"
                 [ngClass]="{'active' : displayType === 'html'}"
                 >Html</label>

          <label class="btn btn-primary" style="color: #f2ffce; text-shadow: none; margin-left: 3px;"
                 [ngClass]="{'active' : displayType === 'raw'}"
                 (click)="onDisplayTypeChange('raw');">Raw</label>
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-model let-rowIndex="rowIndex" let-columns>
    <tr *ngIf="model.name.indexOf(selectedMediaType) === 0 || selectedMediaType === 'all' ">
      <td class="templatesData"
          [ngClass]="{warning: model.markAsWarning || (requireVoiceFirstNameTTS && model.name.indexOf('voiceFirstNameTTS') !== -1)}"
          style="vertical-align: middle; padding: 4px; font-size: 12px; line-height: 15px; border: 1px solid #ddd;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <span>template.{{model.name}}</span>
      </td>
      <td style="vertical-align: middle; padding: 4px; font-size: 12px; line-height: 15px; border: 1px solid #ddd;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <button type="button" class="btn btn-default toRight" style="padding: 3px; height: 24px"
                *ngIf="isMissingInSource(model.name)"
                aria-label="Left Align"
                (click)="removeVariableFromModelAction(rowIndex, templateUpdateModel.updatedModel)"
                tooltip="Remove field '{{model.name}}' from database model"
                [disabled]="isOnlyPreview"
                >
          <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
        </button>
      </td>
      <td class="templatesData"
          style="cursor: pointer; vertical-align: middle; padding: 4px; font-size: 12px; border: 1px solid #ddd;
          line-height: 15px;">

        <div style="line-height: 18px; cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">

          <textarea
                 [(ngModel)]="model.content"
                 [disabled]="true"
                 style="width: 100%; overflow-x: auto; line-height: 24px; font-size: 13px; height: 33px; resize: vertical;"
                 class='form-control notEditable' *ngIf="displayType !== 'html'">
          </textarea>

          <div
              class="notEditable"
              *ngIf="displayType === 'html'"
              readonly="readOnly"
              style="width: 100%; overflow-x: auto; line-height: 24px; font-size: 13px; height: 33px;
              resize: vertical; outline: none; border: none; box-shadow: none; overflow-y: auto"
              [innerHtml]="(model.content || '' ) | safe: 'html'"
          >
          </div>
        </div>
      </td>


      <td class="templatesData"
          style="vertical-align: middle; padding: 4px; font-size: 12px; line-height: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;border: 1px solid #ddd;">
        <button type="button" class="btn btn-default toRight" style="padding: 3px; height: 24px"
                aria-label="Left Align"
                (click)="setToDbModel(rowIndex, model.content, templateUpdateModel.updatedModel)"
                [disabled]="isOnlyPreview || model.content === undefined"
        >
          <span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
        </button>
      </td>
      <td class="templatesData"
          style="cursor: pointer; vertical-align: middle; padding: 4px; font-size: 12px;border: 1px solid #ddd;">
          <textarea
                 name="template.{{model.name}}"
                 id="{{model.name}}"
                 [ngModel]="templateUpdateModel.updatedModel[model.name]"
                 (ngModelChange)="modelUpdated($event, model.name)"
                 style="width: 100%; overflow-x: auto; line-height: 24px; font-size: 13px; height: 33px; resize: vertical;"
                 [disabled]="isOnlyPreview"
                 class='form-control'
                 (blur)="onBlur($event, true, model.name)"
                 *ngIf="displayType === 'raw'"
                 [ngClass]="{warning: model.markAsWarning}"
          ></textarea>
        <div [hidden]="displayType !== 'html'"
             style="width: 100%; overflow-x: auto; line-height: 24px; font-size: 13px; height: 33px;
             resize: vertical; outline: none; border: none; box-shadow: none; overflow-y: auto"
             contenteditable
             [attr.contenteditable]="!isOnlyPreview"
             id = "template.{{model.name}}"
             (click)="setSelectedIndex($event, model.name)"
             noLine-breaks="false"
             [ng-model]="model.name"
             [innerHtml]="(model.rawDefaultContent || '' ) | safe: 'html'"
             (blur)="setSelectedData(model.name)"
             [ngClass]="{warning: model.markAsWarning}"
             [ngStyle]="{'white-space': isSafari ? 'pre-wrap' : ''}"
        >
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div *ngIf="selectedMediaType === 'voice' && communicationsCategoryId === 'reminder'"
     style="margin-top: 16px;"
>
  <ng-template [featureFlags]="['admin:template:voice:tmp']">
  <p-dropdown
      [options]="voiceTemplateParameters"
      [(ngModel)]="selectedVoiceTemplateParameter"
      (onChange)="onlyTTS()"
      styleClass="form-control"
      [style]="{'width':'20%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
            'height':'36px','padding-left': '16px', 'font-size': '10px', 'text-shadow': 'none' , 'display': 'inline-block'}"
  >
    <ng-template let-item pTemplate="item">
      <div *ngIf="!item.isAlreadyMapped">{{item.label}}</div>
      <div *ngIf="item.isAlreadyMapped" (click)="$event.stopPropagation()" style="color: #6e6e6e">{{item.label}}</div>
    </ng-template>
  </p-dropdown>
  <div class="btn-group btn-toggle" style="padding-left: 16px; display: inline-block">
    <button class="btn btn-lg" [disabled]="isNotTTSorSound" (click)="ttsOrSound()" [ngClass]="{ 'btn-default': !isTTS, 'btn-primary active': isTTS}">TTS</button>
    <button class="btn btn-lg" [disabled]="isOnlyTTS || isNotTTSorSound" (click)="ttsOrSound()" [ngClass]="{ 'btn-default': isTTS, 'btn-primary active': !isTTS}">Sound</button>
  </div>

  <div style="padding-left: 16px; display: 'inline-block'">
    <button type="button" class="btn btn-default toRight"
            aria-label="Left Align"
            tooltip="Add Voice Parameter"
            [disabled]="isOnlyPreview || !canAddNew"
            (click)="addVoiceVariable(templateUpdateModel.updatedModel)"
    >
      <span aria-hidden="true" style="font-size: 15px;"> Add Voice Parameter </span>
    </button>
  </div>

  </ng-template>
</div>

<div style="color: #555; padding-top: 5px;">
  To copy fields from source file to the database model use the copy button in the table header
</div>
<div class="coll-md-12 text-center" *ngIf="loading$ | async">
  <br/>
  <img src="img/loading.gif" alt="loading...."/>
</div>